import { preferenceFields, usageFilters } from './legacyUsageState';

// Component-local state is observed without patching business methods or network clients.
export function legacyComponentUsage(kind) {
  return {
    inject: { chartUsage: { default: null } },
    mounted() {
      if (!this.chartUsage) return;
      const watch = (getter, handler) => this.$watch(getter, value => {
        try { handler(value); } catch (_) { /* Optional instrumentation. */ }
      }, { immediate: true, deep: true });
      if (kind === 'header' || kind === 'table' || kind === 'list') {
        // The classic header can hide default chips without removing the preference.
        watch(() => preferenceFields(kind === 'header' && this.barPreferences ? this.barPreferences : this.preferences), fields => this.chartUsage.state(kind === 'header' ? 'metric_fields' : kind === 'table' ? 'table_fields' : 'list_fields', fields));
      }
      if (kind === 'header') {
        watch(() => {
          const p = this.activePortfolio || {};
          return { currency: p.currency, risk: p.risk, risk_strategy: p.risk_strategy };
        }, portfolio => {
          if (!portfolio) return;
          ['currency', 'risk', 'risk_strategy'].forEach(key => {
            if (portfolio[key] != null) this.chartUsage.state(`portfolio_${key === 'risk_strategy' ? 'strategy' : key}`, portfolio[key]);
          });
        });
      }
      if (kind === 'preference-dialog') {
        watch(() => this.show_window, open => this.chartUsage.panel('header_dialog', open ? 'preferences' : ''));
      }
      if (kind === 'left') {
        watch(() => [this.show_searches, this.show_valores_cartera, this.show_link_favorites], ([search, portfolio, favorites]) => {
          this.chartUsage.panel('left_dialog', search ? 'saved-searches' : portfolio ? 'portfolio' : favorites ? 'favorites' : '');
        });
      }
      if (kind === 'filters') {
        watch(() => this.draft, draft => this.chartUsage.state('filter_draft', usageFilters(draft)));
        watch(() => Boolean(this.error), error => this.chartUsage.state('error', error ? 'filters' : ''));
      }
      if (kind === 'list') {
        watch(() => [this.show_workspace, this.show_waiting], ([favorites, portfolio]) => {
          this.chartUsage.panel('chart_dialog', favorites ? 'favorites' : portfolio ? 'portfolio' : '');
        });
      }
      if (kind === 'chart') {
        watch(() => [this.isIframeLoading, Boolean(this.iframeError)], ([loading, error]) => {
          this.chartUsage.state('state', { chart_loading: loading, chart_error: error });
        });
      }
    },
    beforeDestroy() {
      if (kind === 'preference-dialog' && this.chartUsage) this.chartUsage.panel('header_dialog', '');
      if (kind === 'list' && this.chartUsage) this.chartUsage.panel('chart_dialog', '');
      if (kind === 'left' && this.chartUsage) this.chartUsage.panel('left_dialog', '');
    }
  };
}
